const PracticeAreasConstants = {
  ARBITRATION: '/practiceAreas/arbitration',
  COMPETITION: '/practiceAreas/competition',
  // CORPORATE: "/practiceAreas/corporate",
  CORPORATE_GOVERNANCE: '/practiceAreas/corporateGovernance',
  INTELLECTUAL: '/practiceAreas/Intellectual Property',
  MAIN_PRACTICE_AREA: '/practiceAreas/mainPracticeArea',
  REAL_ESTATE: '/practiceAreas/realEstate',
  TRANSPORTATION: '/practiceAreas/transportation',
  AVIATION: '/practiceAreas/aviation',
  CONSTRUCTION: '/practiceAreas/construction',
  EMPLOYMENT: '/practiceAreas/employment',
  // JOIN_VENTURES: '/practiceAreas/joinVentures',
  MERGER_AND_ACQUISITION: '/practiceAreas/mergerAndAcquisition',
  RENEWABLE_ENERGY: '/practiceAreas/renewableEnergy',
  WHITE_COLLAR_CRIME: '/practiceAreas/whiteCollarCrime',
  BANKING_AND_FINANCE: '/practiceAreas/bankingAndFinance',
  CORPORATE: '/practiceAreas/corporate',
  ENERGY: '/practiceAreas/energy',
  LITIGATION: '/practiceAreas/litigation',
  OIL_AND_GAS: '/practiceAreas/oilAndGas',
  TECHNOLOGY: '/practiceAreas/technology',
};

export default PracticeAreasConstants;
